/* unplugin-vue-components disabled */import { render } from "./SpeachGrid.vue?vue&type=template&id=3fa6137a&scoped=true&ts=true"
import script from "./SpeachGrid.vue?vue&type=script&lang=ts"
export * from "./SpeachGrid.vue?vue&type=script&lang=ts"

import "./SpeachGrid.vue?vue&type=style&index=0&id=3fa6137a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa6137a"]])

export default __exports__